import React from "react";
import { ITypographyProps } from "../../@interfaces";



const Subtitle = ({ children, className, ...props }: ITypographyProps) => {
  return (
    <h2
      className={`text-sm font-medium text-gray-700 ${className ?? ""}`}
      {...props}
    >
      {children}
    </h2>
  )
}

export default Subtitle;